import React from "react";
import withAnimation from "../../../utils/withAnimation";

const ContactDetailsWrapper = (props) => (
  <div className="cff-contactDetailsWrapper">{props.children}</div>
);

export default withAnimation(ContactDetailsWrapper);
